const defaultOpts = {
  template: "",
  domElementGetter: null,
};

export default function singleSpaHtml(opts) {
  opts = { ...defaultOpts, ...opts };

  if ((typeof opts.template !== "string" || opts.template.trim().length === 0) && typeof opts.template !== "function") {
    throw Error(`'template' opt must be passed that is a non empty string or function`);
  }

  return {
    bootstrap: bootstrap.bind(null, opts),
    mount: mount.bind(null, opts),
    unmount: unmount.bind(null, opts),
  };
}

function bootstrap(opts, props) {
  return Promise.resolve();
}

function mount(opts, props) {
  return Promise.resolve(typeof opts.template === "function" ? opts.template(props) : opts.template).then(
    (template) => {
      const domElementGetter = chooseDomElementGetter(props);
      const domEl = domElementGetter();
      domEl.innerHTML = template;
    }
  );
}

function unmount(opts, props) {
  return Promise.resolve().then(() => {
    const domElementGetter = chooseDomElementGetter(props);
    const domEl = domElementGetter();
    domEl.innerHTML = "";
  });
}

function chooseDomElementGetter(props) {
  return defaultDomElementGetter(props);
}

function defaultDomElementGetter(props) {
  const name = props.appName || props.name;

  if (!name) {
    throw Error(
      `Single spa application was not given an application name as a prop, so it can't make a unique dom element container for the html application`
    );
  }
  const htmlId = `single-spa-application:${name}`;

  return function defaultDomEl() {
    let domElement = document.getElementById(htmlId);
    if (!domElement) {
      domElement = document.createElement("div");
      domElement.id = htmlId;
      document.body.appendChild(domElement);
    }

    return domElement;
  };
}
